import { Flex, FormControl, FormLabel, Switch, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Mode } from 'src/types/crudTable';
import { useTableContext } from './useTableContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PreviewToggle = function PreviewToggle() {
  var _useTableContext = useTableContext(),
      mode = _useTableContext.mode,
      setMode = _useTableContext.setMode,
      changes = _useTableContext.changes;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var changeHandler = function changeHandler() {
    if (mode === Mode.PREVIEW) {
      setMode(Mode.EDIT);
    } else {
      setMode(Mode.PREVIEW);
    }
  };

  var changeCount = Object.keys(changes).length;
  return /*#__PURE__*/_jsxs(FormControl, {
    display: "flex",
    alignItems: "center",
    e2eid: "CrudTable_EditHeler_FormControl",
    children: [/*#__PURE__*/_jsx(FormLabel, {
      htmlFor: "preview-toggle",
      mb: "0",
      color: mode === Mode.PREVIEW ? 'blue.400' : 'blackAlpha.300',
      fontWeight: "400",
      e2eid: "CrudTable_EditHeler_FormLabel",
      children: t('common:table.previewChanges', '預覽所有修改')
    }), /*#__PURE__*/_jsx(Switch, {
      id: "preview-toggle",
      onChange: changeHandler,
      isDisabled: changeCount === 0,
      e2eid: "CrudTable_EditHeler_Switch"
    })]
  });
};

export var EditHelper = function EditHelper() {
  var _useTableContext2 = useTableContext(),
      mode = _useTableContext2.mode,
      table = _useTableContext2.table;

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  if (mode === Mode.VIEW) {
    return null;
  }

  var selectedRowsCount = table.getSelectedRowModel().rows.length;
  return /*#__PURE__*/_jsxs(Flex, {
    w: "full",
    bg: "#EBF8FF",
    px: 3,
    py: 1,
    gap: 3,
    e2eid: "CrudTable_EditHeler_Flex",
    children: [/*#__PURE__*/_jsx(Text, {
      whiteSpace: "nowrap",
      e2eid: "CrudTable_EditHeler_Text",
      children: t('common:table.selectedCount', "\u5DF2\u9078\u64C7 ".concat(selectedRowsCount, " \u7B46"), {
        selectedRowsCount: selectedRowsCount
      })
    }), /*#__PURE__*/_jsx(PreviewToggle, {
      e2eid: "CrudTable_EditHeler_PreviewToggle"
    })]
  });
};